import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { motion } from "framer-motion";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import aboutAPI from "../api/aboutApi";
import { ArrowLeft } from "lucide-react";

const VisitorGuestDetail = () => {
  const { id } = useParams();

  const [guest, setGuest] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const fetchGuest = async () => {
      setLoading(true);
      setError(false);

      try {
        // Fetch all visitors and find the selected guest by ID.
        const response = await aboutAPI.visitors_guests_api();

        if (!isMounted) return;

        const guests =
          response?.code === 200 && Array.isArray(response.data)
            ? response.data
            : [];

        const selectedGuest = guests.find(
          (item) => String(item.id) === String(id)
        );

        if (selectedGuest) {
          setGuest(selectedGuest);
        } else {
          setGuest(null);
          setError(true);
        }
      } catch (err) {
        console.error("Error fetching guest details:", err);

        if (isMounted) {
          setGuest(null);
          setError(true);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchGuest();

    return () => {
      isMounted = false;
    };
  }, [id]);

  return (
    <div className="visitor-single-root">
      <BreadCrumbBanner
        title={guest?.name || "Visitor Details"}
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      <section className="mrv-single-section">
        <div className="container">
          <div className="mrv-single-back">
            <Link to="/visitors-and-guests">
              <ArrowLeft/>
              <span>Back to Visitors & Guests</span>
            </Link>
          </div>

          {loading ? (
            <div className="mrv-single-message">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p>Loading guest details...</p>
            </div>
          ) : error || !guest ? (
            <div className="mrv-single-message">
              <i className="fa-regular fa-face-frown"></i>
              <h3>Guest Not Found</h3>
              <p>The visitor details could not be found.</p>
              <Link
                to="/visitors-and-guests"
                className="mrv-single-back-btn"
              >
                View All Visitors
              </Link>
            </div>
          ) : (
            <motion.article
              className="mrv-single-card"
              initial={{ opacity: 0, y: 25 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div className="mrv-single-heading">
                <span className="mrv-single-eyebrow">
                  DISTINGUISHED VISITS
                </span>

                <h1>{guest.name}</h1>

                <span className="mrv-single-divider"></span>

                <div className="d-flex align-items-center justify-content-center gap-2">
                    {guest.designation && (
                  <p className="mrv-single-designation">
                    {guest.designation}
                  </p>
                )}{"-"}

                {guest.date && (
                  <div className="mrv-single-date">
                    <i className="fa-regular fa-calendar-days"></i>
                    <span>{guest.date}</span>
                  </div>
                )}
                </div>
              </div>

              {guest.image && (
                <div className="mrv-single-image-wrap">
                  <img
                    src={guest.image}
                    alt={guest.name || "Distinguished guest"}
                    className="mrv-single-image"
                  />
                </div>
              )}

              {guest.description && (
                <div
                  className="mrv-single-description"
                  dangerouslySetInnerHTML={{
                    __html: guest.description,
                  }}
                />
              )}

               {guest.longDesc && (
                <div
                  className="mrv-single-description1"
                  dangerouslySetInnerHTML={{
                    __html: guest.longDesc,
                  }}
                />
              )}

            </motion.article>
          )}
        </div>
      </section>
    </div>
  );
};

export default VisitorGuestDetail;